<template>
  <d-card class="">
    <d-collapse
      id="accordion1"
      accordion="my-accordion"
      v-for="(supply, index) in supplies"
      v-if="index !== '0'"
      :key="'supply-' + index">
      <d-card-body style="padding: 1rem;">
        <span class="mr-2">{{supply.supplier_name}}</span>
        <span
          :style="supply.orders_count_with_payment === supply.orders_count ?
          'color: #17c671; font-weight: 700;' : 'color: #007bff; font-weight: 700;'">
          {{ supply.orders_count }}</span>
        <d-button
          :ref="`button-supplies-${index}`"
          v-d-toggle="`snc-${index}`"
          :class="'collapse_button'"
          outline
          :theme="'light'">
          <i class="material-icons">keyboard_arrow_down</i>
        </d-button>
        <div class="orderCollapse">
          <d-collapse
            class="orderCollapse"
            :id="`snc-${index}`">
            <div class="p-3 mt-3 border rounded">
              <table
                class="table mt-0 mb-0"
                style="text-align: center;">
                <thead class="bg-light">
                  <tr>
                    <th
                      scope="col"
                      class="border-0">Do zapłaty</th>
                    <th
                      scope="col"
                      class="border-0">Przyjęto</th>
                    <th
                      scope="col"
                      class="border-0">Zamówienia</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="align-middle">{{supply.price.toFixed(2)}} zł </td>
                    <td class="align-middle">{{(supply.payment_cash + supply.payment_transferred + supply.payment_card).toFixed(2)}} zł </td>
                    <td class="align-middle">{{supply.orders_count}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </d-collapse>
        </div>
      </d-card-body>
    </d-collapse>
  </d-card>
</template>

<script>
export default {
  name: 'orders-collapse-supplies',
  props: {
    supplies: {
      type: [Object, Array],
      required: true
    }
  }
};
</script>
